import { withInstall, withNoopInstall } from '@bigin/utils'

import Descriptions from './src/description.vue'
import DescriptionsItem from './src/description-item'

export const BDescriptions = withInstall(Descriptions, {
  DescriptionsItem,
})

export const BDescriptionsItem = withNoopInstall(DescriptionsItem)

export default BDescriptions

export * from './src/description'
